// EditProfileModal.tsx
import React, { useEffect, useState } from "react";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/Dropdown";
import { Btn } from "../../../AbstractElements";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";
import {
  useEditProfile,
  useEmployeeGeoTown,
  useGetDesignationsData,
  useGetEmployeeStatusData,
  useGetEODstatus,
  useGetFullSyncStatus,
  usePositionData,
  useReportingToPositionData,
  useSingleAttendance,
  useUpdateAttendance,
} from "../hooks/useEmployee";
import { useGetLanguagesData } from "../../edetailing/hooks/useEdetailing";
import { BASE_URL } from "../../../Api/config";
import { handleMedia } from "../../edetailing/repository/EdetailingRepository";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { Spinner } from "reactstrap";
import { showToast } from "../../../utils/toastUtils";

const AttendanceModal = ({
  attendanceData,
  employeeData,
  toggleModal,
  refresh,
}: any) => {
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [AttendanceDate, setAttendanceDate] = useState("");
  const [startTown, setStartTown] = useState("");
  const [endTown, setEndTown] = useState("");
  const [duration, setDuration] = useState("");
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState("");
  const [expenseGenarated,setExpenseGenarated]=useState(false)
  const [isFormReady,setIsFormReady]=useState(false)
  const [initialForm, setInitialForm] = useState<any>(null);


  console.log("attendanceData", attendanceData);
  console.log("employeeData", employeeData);

  const { data: singleAttendance } = useSingleAttendance({
    id: attendanceData?.raw?.AttendanceId,
    enabled: !!attendanceData?.raw?.AttendanceId,
  });

  console.log("singleATtendance", singleAttendance?.data);

  const { data: geoTown } = useEmployeeGeoTown({
    enabled: !!employeeData?.PositionId,
    params: {
      positionId: employeeData?.PositionId,
      fetch: "all",
    },
  });

  const FormattedHQTown = Object.entries(
    geoTown?.data?.EmployeeGeoTowns || {}
  ).map((item: any) => ({
    id: item[0],
    label: item[1],
  }));

  const formattedStatus = Object.entries(
    singleAttendance?.data?.StatusOptions || {}
  ).map((item: any) => ({
    id: item[0],
    label: item[1],
  }));

  // helper function to calculate duration in minutes
  const calculateDuration = (start: string, end: string): string => {
    if (!start || !end) return "";

    const [sh, sm] = start.split(":").map(Number);
    const [eh, em] = end.split(":").map(Number);

    const startMinutes = sh * 60 + sm;
    const endMinutes = eh * 60 + em;

    let diff = endMinutes - startMinutes;
    if (diff < 0) diff += 24 * 60; // handle next day case

    return diff.toString();
  };

  // Populate initial values from API
  // useEffect(() => {
  //   if (singleAttendance) {
  //     setAttendanceDate(singleAttendance?.data?.AttendanceDate || "");
  //     setStartTime(singleAttendance?.data?.StartTime || "");
  //     setStartTown(singleAttendance?.data?.StartTown?.Itownid || "");
  //     setEndTime(singleAttendance?.data?.EndTime || "");
  //     setEndTown(singleAttendance?.data?.EndTown?.Itownid || "");
  //     setRemark(singleAttendance?.data?.Remark || "");
  //     setStatus(String(singleAttendance?.data?.Status ?? ""));

  //       setExpenseGenarated(singleAttendance?.data?.ExpenseGenerated||false)
      

  //     if (singleAttendance?.data?.StartTime && singleAttendance?.data?.EndTime) {
  //       setDuration(
  //         calculateDuration(
  //           singleAttendance?.data?.StartTime,
  //           singleAttendance?.data?.EndTime
  //         )
  //       );
  //     }
  //     setIsFormReady(true);
  //   }
  // }, [singleAttendance]);

  useEffect(() => {
  if (singleAttendance) {
    const initValues = {
      AttendanceDate: singleAttendance?.data?.AttendanceDate || "",
      StartTime: singleAttendance?.data?.StartTime || "",
      StartTown: singleAttendance?.data?.StartTown?.Itownid || "",
      EndTime: singleAttendance?.data?.EndTime || "",
      EndTown: singleAttendance?.data?.EndTown?.Itownid || "",
      Remark: singleAttendance?.data?.Remark || "",
      Status: String(singleAttendance?.data?.Status ?? ""),
      ExpenseGenerated: singleAttendance?.data?.ExpenseGenerated || false,
    };

    // Populate states
    setAttendanceDate(initValues.AttendanceDate);
    setStartTime(initValues.StartTime);
    setStartTown(initValues.StartTown);
    setEndTime(initValues.EndTime);
    setEndTown(initValues.EndTown);
    setRemark(initValues.Remark);
    setStatus(initValues.Status);
    setExpenseGenarated(initValues.ExpenseGenerated);

    if (initValues.StartTime && initValues.EndTime) {
      setDuration(calculateDuration(initValues.StartTime, initValues.EndTime));
    }

    setInitialForm(initValues);     // store the original form values
    setIsFormReady(true);
  }
}, [singleAttendance]);

const isFormChanged =
  initialForm &&
  (
    AttendanceDate !== initialForm.AttendanceDate ||
    startTime !== initialForm.StartTime ||
    startTown !== initialForm.StartTown ||
    endTime !== initialForm.EndTime ||
    endTown !== initialForm.EndTown ||
    remark !== initialForm.Remark ||
    status !== initialForm.Status ||
    expenseGenarated !== initialForm.ExpenseGenerated
  );



  // auto-update duration when user changes times in modal
  useEffect(() => {
    if (startTime && endTime) {
      setDuration(calculateDuration(startTime, endTime));
    }
  }, [startTime, endTime]);

  const {mutate:submitAttendance,isPending:isSubmit}=useUpdateAttendance()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if(!startTime){
      showToast.warning("Please enter Start Time")
      return;
    }

    if (status === "1" && (!endTime)) {
    showToast.warning("Please enter End Time before submitting.");
    return; 
  }  
  if (status === "1" && (!endTown )) {
    showToast.warning("Please enter End Town before submitting.");
    return; 
  }
  const payload = {
    empId: employeeData?.EmployeeId,
    id: attendanceData?.raw?.AttendanceId,
    AttendanceDate: AttendanceDate,
    StartTime: startTime,
    StartItownid: startTown,
    EndTime: status === "0" ? "" : endTime,         // 👈 condition
    EndItownid: status === "0" ? "" : endTown,     // 👈 condition
    ShiftMins: status==="0"?"":duration,
    Remark: remark,
    Status: status,
  };
    submitAttendance(payload,{onSuccess:()=>toggleModal()})
  };

  return (
    <>
     {!isFormReady && !singleAttendance ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      ) :(
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6">
          <CustomInput
            disabled
            label="Attendance Date"
            type="date"
            className="form-control"
            placeholder="Enter Attendance Date"
            value={AttendanceDate}
            onChange={(e) => setAttendanceDate(e.target.value)}
          />
        </div>

        <div className="col-md-6">
          <CustomInput
            type="time"
            className="form-control"
            label="Start Time"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
          />
        </div>

        <div className="col-md-6">
          <RouteDropdown
            DropdownHeading="Start Town"
            value={startTown}
            onChange={(value: any) => setStartTown(value)}
            options={FormattedHQTown || []}
          />
        </div>

        <div className="col-md-6">
          <CustomInput
          label="End Time"
            type="time"
            className="form-control"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
          />
        </div>

        <div className="col-md-6">
          <RouteDropdown
            DropdownHeading="End Town"
            value={endTown}
            onChange={(value: any) => setEndTown(value)}
            options={FormattedHQTown || []}
          />
        </div>

        <div className="col-md-6">
          <CustomInput
          label="Duration (min)"
            type="text"
            className="form-control"
            placeholder="Duration"
            value={duration}
            readOnly // 👈 makes it auto-calculated only
          />
        </div>

        <div className="col-md-6">
          <CustomInput
          label="Remark"
            type="text"
            className="form-control"
            placeholder="Remark"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </div>

        <div className="col-md-6">
          <RouteDropdown
            DropdownHeading="Status"
            value={status}
            onChange={(value: any) => setStatus(value)}
            options={formattedStatus || []}
          />
        </div>
          <div className="col-md-6" style={{marginTop:'15px'}}>
          <input
          style={{marginRight:'5px'}}
            className="form-check-input"
            type="checkbox"
            id="isDefault"
            checked={expenseGenarated}
            onChange={(e) => setExpenseGenarated(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="isDefault">
            Expense Generated
          </label>
        </div>
      </div>

      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
  style={{ backgroundColor: "#43B9B2", color: "white" }}
  type="submit"
  disabled={!isFormChanged || isSubmit}   // 👈 disable unless form changed
>
  {isSubmit ? "Submitting..." : "Submit"}
</Btn>

        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={() => {
            toggleModal();
          }}
        >
          Cancel
        </Btn>
      </div>
    </form>
  )
}
</>
  )
};

export default AttendanceModal;
